import { getVendorCategories } from "api/vendor";
import CustomReactSelect from "components/CustomReactSelect";
import PropTypes from "prop-types";
import { useEffect } from "react";
import useGlobalStore from "store/useGlobalStore";


const VendorCategorySelector = ({
    value,
    onChange,
    label = "Vendor Category",
    placeholder = "Select Category...",
    isMulti = false,
    required = false,
    disabled = false,
    ...props
}) => {
    const { vendorCategories, setVendorCategories } = useGlobalStore();

    useEffect(() => {
        if (vendorCategories.length <= 0) {
            handleFetch();
        }
    }, []);

    const handleFetch = async () => {
        // If categories already exist, return them instead of making API call
        if (vendorCategories.length > 0) {
            return vendorCategories;
        }

        try {
            const response = await getVendorCategories({ get_all: true });
            const data = response.data?.data ?? [];
            const dataOptions = data.map(vendorCategory => ({
                label: vendorCategory,
                value: vendorCategory
            }));
            setVendorCategories(dataOptions);
            return dataOptions;
        } catch (error) {
            return [];
        }
    };

    const getSelectedValue = () => {
        if (!value) return null;
        if (isMulti) {
            return vendorCategories.filter(option => value.includes(option.value)) || null;
        }
        return vendorCategories.find(option => option.value === value) || null;
    };

    const handleChange = (selectedOption) => {
        if (isMulti) {
            const selectedValues = selectedOption ? selectedOption.map(opt => opt.value) : [];
            if (onChange) {
                onChange(selectedValues, selectedOption);
            }
        } else {
            const selectedValue = selectedOption ? selectedOption.value : null;
            if (onChange) {
                onChange(selectedValue, selectedOption);
            }
        }
    };


    return (
        <CustomReactSelect
            label={label}
            isMulti={isMulti}
            isClearable
            cacheOptions={true}
            loadOptions={handleFetch}
            value={getSelectedValue()}
            options={vendorCategories}
            onChange={handleChange}
            placeholder={placeholder}
            required={required}
            disabled={disabled}
            noOptionsMessage={() => "No vendor categories found"}
            {...props}
        />
    );
};

VendorCategorySelector.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object,
        PropTypes.string,
        PropTypes.number,
    ]),
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    isMulti: PropTypes.bool,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
};

export default VendorCategorySelector;